
import { defineComponent } from "vue";
import { useStore } from "vuex";
import GenericPanel from "../shared/GenericPanel.vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
    name: "SPECIAL",
    setup() {
        const store = useStore();
        const getColor = (stat: string) => {
            const diff = store.state.build.SPECIAL[stat].onDrugs - store.state.build.SPECIAL[stat].value;
            if (!diff) {
                return '';
            }
            else if (diff > 0) {
                return 'color: #d7ffa6;';
            }
            else {
                return 'color: #ffeab7;';
            }
        };
        const showInfo = (category: string, stat: string) => {
            store.dispatch('handleIncomingCommand', {
                command: 'updateInfoPanel',
                data: { category, stat }
            });
        };
        const isImplantAvailable = (stat: string) => {
            return store.state.build.SPECIAL[stat].value < 10 &&
                !store.state.build.SPECIAL[stat].implanted &&
                store.state.build.info.currentLevel >= 30;
        };
        const isImplanted = (stat: string): boolean => {
            return store.state.build.SPECIAL[stat].implanted;
        };
        const implantSPECIAL = (stat: string) => {
            store.dispatch('handleIncomingCommand', {
                command: 'implantSPECIAL',
                data: { stat }
            });
        };
        return {
            state: store.state,
            SPECIAL: store.state.build.SPECIAL,
            getColor,
            showInfo,
            isImplantAvailable,
            isImplanted,
            implantSPECIAL
        };
    },
    components: { GenericPanel, GenericButton }
});
